"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFiltersCustomizer = void 0;
var attributeFiltersCustomizer_1 = require("./attributeFiltersCustomizer");
var dateFiltersCustomizer_1 = require("./dateFiltersCustomizer");
var DefaultFiltersCustomizer = /** @class */ (function () {
    function DefaultFiltersCustomizer(logger) {
        var _this = this;
        this.logger = logger;
        this.attributeFiltersCustomizer = new attributeFiltersCustomizer_1.DefaultAttributeFiltersCustomizer(this.logger);
        this.dateFiltersCustomizer = new dateFiltersCustomizer_1.DefaultDateFiltersCustomizer(this.logger);
        this.sealCustomizer = function () {
            _this.attributeFiltersCustomizer.sealCustomizer();
            _this.dateFiltersCustomizer.sealCustomizer();
            return _this;
        };
    }
    DefaultFiltersCustomizer.prototype.attribute = function () {
        return this.attributeFiltersCustomizer;
    };
    DefaultFiltersCustomizer.prototype.date = function () {
        return this.dateFiltersCustomizer;
    };
    return DefaultFiltersCustomizer;
}());
exports.DefaultFiltersCustomizer = DefaultFiltersCustomizer;
//# sourceMappingURL=filtersCustomizer.js.map